// dashboard/composables/useFaqAlert.js
import { ref } from 'vue';
import axios from 'axios';

const faqPendingCount = ref(0);
const faqOldestDays = ref(0);

export function useFaqAlert() {
  const fetchFaqPendingAlert = async (accountId) => {
    try {
      const { data } = await axios.get('https://api.wellon.digital/painel/chatwoot/faq/alerta-pendentes', {
        params: { account_id: accountId, days: 90 },
      });
      faqPendingCount.value = data.count;
      faqOldestDays.value = data.oldest_days || 0;
    } catch (e) {
      faqPendingCount.value = 0;
      faqOldestDays.value = 0;
    }
  };

  return { faqPendingCount, faqOldestDays, fetchFaqPendingAlert };
}